define([
    'jquery',
    './console',
], function ($, console) {
    'use strict';

    const reCaptchaV3 = require('recaptcha-v3/dist/ReCaptcha');
    const recaptchaLoad = reCaptchaV3.load;


    const isValidEmail = function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    const autoExpand = function (field) {

        // Reset field height
        field.style.height = 'inherit';

        // Get the computed styles for the element
        var computed = window.getComputedStyle(field);

        // Calculate the height
        var height = parseInt(computed.getPropertyValue('border-top-width'), 10)
            + parseInt(computed.getPropertyValue('padding-top'), 10)
            + field.scrollHeight
            + parseInt(computed.getPropertyValue('padding-bottom'), 10)
            + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

        field.style.height = height + 'px';
    };

    const handleAttachExpandTextarea = function(event) {
        if (event.target.tagName.toLowerCase() !== 'textarea') return;
        autoExpand(event.target);
    };

    let $form;


    const activate = function () {
        // autoExpand the text area as they type
        document.addEventListener('input', handleAttachExpandTextarea, false);

        $form = $('.js-form-booking');

        let $form_wrapper = $form.parent('.js-form-booking-parent'),
            url = $form.attr('action'),
            hasError = false,
            data = {},

            // csrf
            $tokenInputField = $form.find('#token'),
            postTokenName = $tokenInputField.attr('name'),
            postTokenValue = $tokenInputField.val(),

            // form fields
            $name = $form.find('[name=name]'),
            $email = $form.find('[name=email]'),
            $phone = $form.find('[name=phone]'),
            $number_adults = $form.find('[name=number_adults]'),
            $number_children = $form.find('[name=number_children]'),
            $checkin_date = $form.find('[name=checkin_date]'),
            $checkout_date = $form.find('[name=checkout_date]'),
            $message = $form.find('[name=message]'),
            $names_ = $form.find('[name=names_]'),
            $reference = $form.find('[name=reference]'),
            // $recaptcha_response = $form.find('[name=recaptcha_response]'),
            $form_name = $form.find('[name=form_name]'),
            $submit = $form.find('[name=submit]');

        $form.on('submit', function (event) {
            event.preventDefault();

            $form.find('input').prop("disabled", true);
            $form.find('.error').remove();
            $form.find('.has-error').removeClass('has-error');
            $form.find('.field_error').removeClass('field_error');
            hasError = false;

            $submit.addClass('loading');

            if ($name.val() === '') {
                hasError = true;
                $name.addClass('field_error');
                $name.after("<span class='error'>The field is required</span>");
            }

            if (!isValidEmail($email.val())) {
                hasError = true;
                $email.addClass('field_error');
                $email.after("<span class='error'>Please, enter valid email</span>");
            }

            if ($phone.val() === '') {
                hasError = true;
                $phone.addClass('field_error');
                $phone.after("<span class='error'>The field is required</span>");
            }

            if ($number_adults.val() === '') {
                hasError = true;
                $number_adults.addClass('field_error');
                $number_adults.after("<span class='error'>The field is required</span>");
            }

            if (hasError) {
                $form.find('input').prop("disabled", false);
                $submit.removeClass('loading');
                return false;
            }

            recaptchaLoad('6LfDgkUqAAAAACYPX0bxk5lehgnfJTKmCJoVEH6x').then(function (recaptcha) {
                recaptcha.execute('booking_form').then(function (token) {
                    console.log(token);

                    data = {
                        form_name: $form_name.val() || '',
                        name: $name.val() || '',
                        email: $email.val() || '',
                        phone: $phone.val() || '',
                        number_adults: $number_adults.val() || '',
                        number_children: $number_children.val() || '',
                        checkin_date: $checkin_date.val() || '',
                        checkout_date: $checkout_date.val() || '',
                        message: $message.val() || '',
                        reference: $reference.val() || '',
                        names_: $names_.val() || '',
                        // recaptcha_response: $recaptcha_response.val() || '',
                        recaptcha_token: token,
                        submit: $submit.val() || ''
                    };

                    $.ajax({
                        method: 'POST',
                        url: url,
                        beforeSend: function (request) {
                            request.setRequestHeader('X-' + postTokenName, postTokenValue);
                        },
                        data: data,
                        dataType: 'json'
                    })
                        .done(function (data) {
                            if (data.error) {
                                $form.find('.error').remove();
                                $form.find('.field_error').removeClass('field_error');

                                $.each(data.errors, function (field, msg) {
                                    if (field === 'form') {
                                        $form.prepend("<span class='error'>" + msg + "</span>");
                                    } else {
                                        var $field = $('#' + field);
                                        $field.addClass('field_error');
                                        $field.after("<span class='error'>" + msg + "</span>");
                                    }
                                });

                            } else {
                                if (data.message) {
                                    $form_wrapper.slideUp(400, function () {
                                        $form_wrapper.html(data.message);
                                        $form_wrapper.slideDown(300);
                                    });


                                    // Track the form submission in GA4
                                    trackEventAsync('form_submit', {
                                        event_category: 'Form',
                                        event_label: 'Booking Form',
                                        value: 1
                                    });
                                }
                            }

                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            alert(textStatus, errorThrown);
                        })
                        .always(function () {
                            $submit.removeClass('loading');
                            $form.find('.js-input').prop("disabled", false);
                            $form.find('.js-submit').removeClass('loading');
                        });

                });
            });
        });
    };

    const deactivate = function () {
        document.removeEventListener('input', handleAttachExpandTextarea, false);

        $form.off('submit');
    };

    function trackEventAsync(eventName, params) {
        if (typeof gtag === 'function') {
            gtag('event', eventName, params);

            console.log('GA4 ' + eventName + ' tracked for: ', params);
        } else {
            setTimeout(function () {
                trackEventAsync(eventName, params);
            }, 100); // Retry after 100ms
        }
    }

    return {
        activate: activate,
        deactivate: deactivate,
    };
});
